<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <p>{{ message }}</p>
</mat-dialog-content>
<mat-dialog-actions >
  <button
    type="button"
    class="btn-save"
    mat-raised-button
    (click)="dialogRef.close(true)">
    {{ actionBtn || "OK" }}
  </button>
  <button type="button" mat-raised-button (click)="dialogRef.close()">
    {{ cancelBtn || "Cancel" }}
  </button>
</mat-dialog-actions>
